import { fromJS } from 'immutable';
import * as ActionTypes from './action-types';

class LoadingGroup {
  constructor(fetchesInProgress = 0) {
    this.fetchesInProgress = fetchesInProgress;
    this.isLoading = fetchesInProgress > 0;
  }

  startFetch() {
    return new LoadingGroup(this.fetchesInProgress + 1);
  }

  completeFetch() {
    return new LoadingGroup(this.fetchesInProgress - 1);
  }
}

const initialState = fromJS({
  loadingGroup: new LoadingGroup(0),
  openValidationRenewal: null
});

function renewalsPortalReducer(state = initialState, action) {
  const currentLoadingGroup = state.get('loadingGroup');
  switch (action.type) {
    case ActionTypes.IS_LOADING:
      return state.set(
        'loadingGroup',
        action.isLoading
          ? currentLoadingGroup.startFetch()
          : currentLoadingGroup.completeFetch()
      );

    case ActionTypes.OPEN_VALIDATION_RENEWAL:
      return state.set('openValidationRenewal', action.renewal);

    case ActionTypes.CLOSE_VALIDATION_RENEWAL:
      return state.set('openValidationRenewal', null);

    case ActionTypes.UPDATE_RENEWAL:
      let oldRenewal = state.get('openValidationRenewal');
      var newRenewal = action.updatedRenewal;
      let updatedRenewal = { ...oldRenewal, ...newRenewal };
      return state.set('openValidationRenewal', updatedRenewal);

    default:
      return state;
  }
}

export default renewalsPortalReducer;
